import axios from 'axios'
import api from 'Api'
import { uuid } from 'vue-uuid'
import { SET_MESSAGE } from '../components/utils'

const URL = '/cyber-security-assessment'

const state = {
  cyberSecurityAssessments: [],
  cyberSecurityAssessmentsLoading: false,

  activeCyberSecurityAssessment: {}
}

const getters = {
  cyberSecurityAssessments: state => {
    return state.cyberSecurityAssessments
  },
  activeCyberSecurityAssessment: state => {
    return state.activeCyberSecurityAssessment
  },
  cyberSecurityAssessmentsLoading: state => {
    return state.cyberSecurityAssessmentsLoading
  }
}

let loadCyberSecurityAssessmentsCancelToken = null
const actions = {
  async loadCyberSecurityAssessments (context, organizationId) {
    if (!organizationId) {
      return
    }

    if (loadCyberSecurityAssessmentsCancelToken) {
      loadCyberSecurityAssessmentsCancelToken.cancel()
    }

    context.commit('SET_CYBER_SECURITY_ASSESSMENTS_LOADING', true)

    let response
    try {
      loadCyberSecurityAssessmentsCancelToken = axios.CancelToken.source()

      response = await api().get(`${URL}/organization/${organizationId}`, { cancelToken: loadCyberSecurityAssessmentsCancelToken.token })
      context.commit('SET_CYBER_SECURITY_ASSESSMENTS', response.data)

      loadCyberSecurityAssessmentsCancelToken = null
    } catch (e) {
      if (e && e.constructor && e.constructor.name === 'Cancel') {
      } else {
        SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
      }
    }

    context.commit('SET_CYBER_SECURITY_ASSESSMENTS_LOADING', false)
  },

  async saveCyberSecurityAssessment (context, payload) {
    let isAddingNew = false
    const oldOnes = state.cyberSecurityAssessments
    if (!payload.entity_id) {
      payload.entity_id = uuid.v4()
      isAddingNew = true

      context.commit('SET_CYBER_SECURITY_ASSESSMENTS', [...state.cyberSecurityAssessments, payload])
    } else {
      context.commit('SET_CYBER_SECURITY_ASSESSMENTS', [...state.cyberSecurityAssessments.map(item => item.entity_id !== payload.entity_id ? item : payload)])
    }

    let response
    try {
      if (isAddingNew) {
        response = await api().post(URL, payload)
      } else {
        response = await api().put(`${URL}`, payload)
      }
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })

      context.commit('SET_CYBER_SECURITY_ASSESSMENTS', oldOnes)

      return
    }

    context.commit('SET_CYBER_SECURITY_ASSESSMENTS', [...state.cyberSecurityAssessments.map(item => item.entity_id !== payload.entity_id ? item : response.data)])

    SET_MESSAGE({ type: 'success', message: 'A cost per record study has been saved successfully.' })
  },

  async deleteCyberSecurityAssessment (context, id) {
    const oldOnes = state.cyberSecurityAssessments

    context.commit('SET_CYBER_SECURITY_ASSESSMENTS', [...state.cyberSecurityAssessments.filter(item => item.entity_id !== id)])

    let response
    try {
      response = await api().delete(`${URL}/${id}`)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })

      context.commit('SET_CYBER_SECURITY_ASSESSMENTS', oldOnes)
    }

    SET_MESSAGE({ type: 'success', message: 'A cost per record study has been deleted successfully.' })
  },

  resetActiveCyberSecurityAssessment (context) {
    const usedIndustries = context.getters.cyberSecurityAssessments.map(({ industry }) => industry)
    const industries = context.getters.costPerRecordStudies.map(({ industry }) => industry).filter(industry => usedIndustries.indexOf(industry) < 0)

    context.commit('SET_ACTIVE_CYBER_SECURITY_ASSESSMENT', {
      industry: industries && industries.length ? industries[0] : null,
      conducted_way: 'self_assessed',
      vendor_name: null,
      report_file: null,

      overall_scoring_method: 'score_based',

      max_potential_score: 0,
      archived_score: 0,

      overall_cyber_strength_score: 0,
      overall_cyber_weakness_score: 0
    })
  },

  async loadActiveCyberSecurityAssessment (context, id) {
    context.commit('SET_ACTIVE_CYBER_SECURITY_ASSESSMENT', state.cyberSecurityAssessments.find(item => item.entity_id === id))

    let response
    try {
      response = await api().get(`${URL}/${id}`)
      context.commit('SET_ACTIVE_CYBER_SECURITY_ASSESSMENT', response.data)
    } catch (e) {
      SET_MESSAGE({ type: 'error', message: (response && response.error) || 'Error' })
    }
  }
}

const mutations = {
  SET_CYBER_SECURITY_ASSESSMENTS (state, cyberSecurityAssessments) {
    state.cyberSecurityAssessments = cyberSecurityAssessments
  },
  SET_CYBER_SECURITY_ASSESSMENTS_LOADING (state, loading) {
    state.cyberSecurityAssessmentsLoading = loading
  },
  SET_ACTIVE_CYBER_SECURITY_ASSESSMENT (state, cyberSecurityAssessment) {
    state.activeCyberSecurityAssessment = cyberSecurityAssessment
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'cyberSecurityAssessmentStore'
}
